// Copyright (c) 2016 Deere & Company

import './status-change-product-info.scss';
import React, {PropTypes} from 'react';
import AdditionalStatusesList from '../product-info-view/additional-statuses-list';
import LabeledString from './../../../../shared/components/labeled-string';
import Product from '@deere/cps-it.warranty-model-factory/lib/product';
import ProductStatusInfo from '../../../shared/components/product-status-info';
import StatusChangeDealerInfo from './status-change-dealer-info';

const StatusChangeProductInfo = ({product}) =>
    <section className='status-change-product-info'>
        <div className='status-change-product'>
            <LabeledString
                data={product.model}
                label='MODEL'
            />

            <ProductStatusInfo
                status={product.status[0]}
            />

            <AdditionalStatusesList
                statuses={product.status.slice(1)}
            />

        </div>

        <div className='status-change-product'>

            <StatusChangeDealerInfo
                dealer={product.dealer}
            />

        </div>

    </section>;

StatusChangeProductInfo.displayName = 'StatusChangeProductInfo';
StatusChangeProductInfo.propTypes = {
    product: PropTypes.instanceOf(Product).isRequired
};

export default StatusChangeProductInfo;



// WEBPACK FOOTER //
// ./src/product/status-change-request/components/product-info-view/status-change-product-info.js